/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Mobile sort-sheet fix (Claude).
 * The collection "Sort by" sheet is position:fixed on mobile. The collection section wrapper
 * .shopify-section.scroll-reveal.is-revealed keeps a leftover transform + will-change:transform after its
 * scroll-reveal animation; a transformed ancestor becomes the containing block for the fixed child, pushing
 * the sort sheet far off-screen. This injects a <=640px override that neutralises the leftover transform.
 */
(function () {
  var css = '@media screen and (max-width: 640px) {' +
    '.shopify-section.scroll-reveal.is-revealed { transform: none !important; will-change: auto !important; }' +
    '}';
  function inject() {
    if (document.getElementById('vero-sort-sheet-fix')) return;
    var style = document.createElement('style');
    style.id = 'vero-sort-sheet-fix';
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }
  if (document.head) { inject(); }
  else if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', inject); }
  else { inject(); }
})();

/**
 * Optional "Vehicle VIN" field on the cart + mini-cart (Claude).
 *
 * Adds a single optional text input so customers can supply their VIN for fitment
 * verification. The value is stored as a Shopify CART ATTRIBUTE named "Vehicle VIN"
 * (input name="attributes[Vehicle VIN]"), so it carries through checkout and shows on
 * the order's "Additional details" for the team to verify fitment. It is never required.
 *
 * Why JS (and not a hand-edit of the 44KB main-cart.liquid): the field is injected into
 * the theme's real cart forms, so it posts as a normal cart attribute on checkout, and is
 * ALSO saved live via /cart/update.js on change so it survives navigation. This keeps the
 * change surgical and isolated inside the theme's sanctioned customisation hook.
 *
 * Surfaces:
 *   - Cart page  -> form.cart-recap (inserted just above the tax/shipping notice, by the checkout button).
 *   - Mini-cart  -> #mini-cart .mini-cart__recap (inserted above the checkout buttons).
 * Does NOT touch the existing order "note" field or any line-item properties.
 */
(function () {
  var ATTR_KEY = 'Vehicle VIN';
  var currentVin = '';

  var CSS = '' +
    '.vero-vin{margin:16px 0 4px;}' +
    '.vero-vin__label{display:block;margin-bottom:6px;font-size:.95em;line-height:1.3;}' +
    '.vero-vin__input{width:100%;box-sizing:border-box;}' +
    '.vero-vin__help{margin:6px 0 0;font-size:.82em;line-height:1.4;opacity:.7;}' +
    '#mini-cart .vero-vin{margin:12px 0 4px;}' +
    '#mini-cart .vero-vin__label{font-size:.9em;}' +
    '#mini-cart .vero-vin__help{font-size:.78em;}';

  function injectStyle() {
    if (document.getElementById('vero-vin-style')) return;
    var style = document.createElement('style');
    style.id = 'vero-vin-style';
    style.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(style);
  }

  function buildField(scope) {
    var wrap = document.createElement('div');
    wrap.className = 'vero-vin';
    wrap.setAttribute('data-vero-vin', scope);

    var id = 'vero-vin-input--' + scope;

    var label = document.createElement('label');
    label.className = 'vero-vin__label text--strong';
    label.setAttribute('for', id);
    label.textContent = 'Vehicle VIN number (optional)';

    var input = document.createElement('input');
    input.type = 'text';
    input.id = id;
    input.name = 'attributes[' + ATTR_KEY + ']';
    input.className = 'vero-vin__input form__field form__field--text';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('maxlength', '40');
    input.setAttribute('placeholder', 'e.g. WBA8E9C50GK123456');
    input.setAttribute('data-vero-vin-input', '');
    input.value = currentVin;

    var help = document.createElement('p');
    help.className = 'vero-vin__help';
    help.textContent = "Add it and we'll verify fitment for you — totally optional.";

    wrap.appendChild(label);
    wrap.appendChild(input);
    wrap.appendChild(help);
    return wrap;
  }

  function injectCartPage() {
    var form = document.querySelector('form.cart-recap');
    if (!form || form.querySelector('[data-vero-vin]')) return;
    var anchor = form.querySelector('.cart-recap__notices') || form.querySelector('.cart-recap__checkout');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(buildField('cart'), anchor);
  }

  function injectMiniCart() {
    var recap = document.querySelector('#mini-cart .mini-cart__recap');
    if (!recap || recap.querySelector('[data-vero-vin]')) return;
    var anchor = recap.querySelector('.mini-cart__button-container');
    if (anchor) {
      recap.insertBefore(buildField('mini'), anchor);
    } else {
      recap.appendChild(buildField('mini'));
    }
  }

  function injectAll() {
    injectStyle();
    injectCartPage();
    injectMiniCart();
  }

  function syncAll(value) {
    currentVin = value;
    var inputs = document.querySelectorAll('[data-vero-vin-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== value) inputs[i].value = value;
    }
  }

  function loadCurrent() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var v = (cart && cart.attributes && cart.attributes[ATTR_KEY]) ? String(cart.attributes[ATTR_KEY]) : '';
        if (v) syncAll(v);
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.matches || !el.matches('[data-vero-vin-input]')) return;
    var value = (el.value || '').trim();
    syncAll(value);
    var body = { attributes: {} };
    body.attributes[ATTR_KEY] = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  });

  function init() {
    injectAll();
    loadCurrent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['cart:refresh', 'product:added', 'cart:updated'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, function () {
      setTimeout(injectAll, 60);
    });
  });

  function observeMiniCart() {
    var mc = document.getElementById('mini-cart');
    if (!mc) return false;
    new MutationObserver(function () { injectAll(); }).observe(mc, { childList: true, subtree: true });
    return true;
  }
  if (!observeMiniCart()) {
    var bodyObs = new MutationObserver(function () {
      if (observeMiniCart()) { bodyObs.disconnect(); injectAll(); }
    });
    bodyObs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
